<template>
    <RouterView />
</template>

<script setup>

</script>

<style lang="scss" scoped>

</style>
